module.exports = __webpack_public_path__ + "static/media/aluFasade.51fbc7f3.jpeg";